import { useTranslation } from 'react-i18next';
import { getIsSupercellTemplate } from '../../utils/get-is-supercell-template';
import { AutoTextSize } from '../Checkout/components/AutoTextSize/AutoTextSize';

import './styles.scss';

const IS_SUPERCELL_TEMPLATE = getIsSupercellTemplate();

interface OfferItemProps {
  itemName: string;
  itemAmount: string;
  itemImage: string;
  itemPrice?: string;
}

const OfferItem = ({ itemName, itemAmount, itemImage, itemPrice }: OfferItemProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });

  if (IS_SUPERCELL_TEMPLATE) {
    return (
      <div className="offer-item-wrapper supercell-template">
        <span title={itemName} className="offer-item-name">
          {itemName}
        </span>
        <span className="offer-item-quantity">{itemAmount}</span>
        <div className="offer-item-price">{itemPrice}</div>
      </div>
    );
  }

  return (
    <div className="offer-item-wrapper">
      <div className="offer-item-image">
        {itemImage && <img src={itemImage} alt={`${itemName}`} />}
      </div>
      <div className="offer-item-content">
        <span className="offer-item-title">{itemName}</span>
        <AutoTextSize mode={'oneline'} maxFontSizePx={16} minFontSizePx={10}>
          <span className="offer-item-amount">{itemAmount}</span>
        </AutoTextSize>
      </div>
    </div>
  );
};

export default OfferItem;
